import * as React from 'react';
import { Panel } from '../../../components/panel/Panel';

export interface IBookingWarningBannerProps {
	propertyId: string | number;
	customerId: string;
}

const currentWarnings = {
	'BC5ECp-PPNE': 'Customer is on 0% commission',
	'ZYaZPM7ehM': 'SnoStation booking - be aware of pricing issues'
};

const getContent = (propertyId: string | number, customerId: string) => {
	return currentWarnings[propertyId] || currentWarnings[customerId];
};

export const BookingWarningBanner: React.FunctionComponent<IBookingWarningBannerProps> = (props) => {
	const { propertyId, customerId } = props;

	const content = getContent(propertyId, customerId);

	return content ? <Panel type="warn" withIcon={true}>{content}</Panel> : null;
};
